import { FormattedMessage } from "react-intl";

type QuotationErrorProps = {
  quotation: any;
};

function QuotationError(props: QuotationErrorProps) {
  const { quotation } = props;

  if (!quotation?.general?.label_creation_error_message) return null;
  return (
    <div className="quotation-error mb-xl">
      <div className="quotation-error__badge">
        <FormattedMessage id="general.error" defaultMessage="Error" />
      </div>
      <div className="text-xs font-medium quotation-error__message">{quotation.general.label_creation_error_message}</div>
    </div>
  );
}

export default QuotationError;
